import axios from 'axios'

const env = (process.env.NODE_ENV === 'production')

const config = () => {
  return {
    url: env ? 'https://fdc-api.brique.kr' : 'http://localhost',
    port: env ? '' : ':'.concat('20004'),
    service: '/fdc/common'
  }
}

export default {
  /**
   * EQP Tree
   */
  getEqpInfoTree: async (treeType) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/eqptree/info/' + treeType)
      return response.data.children === null ? [] : response.data.children
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * 기간별 EQP Tree 조회
   */
  getEqpHistoryTree: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/eqptree/history/' + payload.treeType, { params: payload })
      return response.data.children === null ? [] : response.data.children
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * Code 조회
   * @param {String} codeType
   * @param {*} callback
   * @return List<Map<String,String>>
   */
  getCodesMap: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/codes/' + payload.codeType + '/map', { params: payload })
      return response.data
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * Code 조회
   * @param {String} codeType
   * @param {*} callback
   * @return List<String> codeList
   */
  getCodesString: async (payload) => {
    // const url = config().url.concat(config().port, config().service, '/common/code/list/', codeType)
    const url = config().url.concat(config().port, config().service, '/codes/' + payload.codeType + '/string')
    const result = await axios
      .get(url)
      .then(response => {
        return response.data == null ? [] : response.data
      })
      .catch(err => {
        console.error(err)
      })
    return result
  },

  /**
   * Code 조회
   * @param {String} payload 조회 조건으로 사용할 codeType
   * @param {Function} callback
   * @return List<CodeVO> list
   */
  getCodes: async (payload, callback) => {
    const url = config().url + config().port + config().service + '/codes/' + payload.codeType
    await axios
      .get(url, { params: payload })
      .then((response) => {
        callback(response)
      })
      .catch((err) => {
        console.error(err)
      })
  },

  /**
   * Code 조회
   * @param {Array} payload 조회 조건으로 사용할 codeType Array
   * @param {Function} callback
   * @return List<CodeVO> list
   */
  getMultiTypeCodes: async (payload, callback) => {
    const url = config().url + config().port + config().service + '/codes/code-types'
    await axios
      .get(url, { params: payload })
      .then((response) => {
        callback(response)
      })
      .catch((err) => {
        console.error(err)
      })
  },

  /**
   * Detection
   */
  /**
   * @summary LOT list 조회 (SELECT LOT)
   * @description fab, eqpId, moduleId는 필수
   * @param fab
   * @param eqpId
   * @param moduleId
   * @param recipeId
   * @param fromDate
   * @param toDate
   * @param lastLotCnt
   * @param faultCnt
   * @param alarmCnt
   * @param interlockCnt
   */
  getEqpLots: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/eqp/lots')

    const result = await axios
      .get(url, { params: payload })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.error(err)
      })
    return result
  },

  /**
   * Realtime
   */
  // 해당 장비의 hostIp를 불러온다.
  getEqpHostIps: async (eqpId) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/eqp/host-ips', { params: eqpId })
      console.log(response)
      return response.data
    } catch (error) {
      console.log(error)
    }
  }
}
